// generate VerifyEmailPage component and use login.tsx style
import { use, useActionState, useEffect } from "react";
import { Link, useParams, useSearchParams } from "react-router-dom";
import Label from "../../components/label";
import Input from "../../components/input";
import { Button } from "../../components/button";
import {
  AtSymbolIcon,
  ExclamationCircleIcon,
  ArrowRightIcon,
} from "@heroicons/react/24/outline";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import FormError from "../../components/form-error";
import Fonts from "../../core/fonts";
import { verifyEmail,State } from "./actions/verifyEmail";
import AuthService from "../../services/AuthService";
import UsersService from "../../services/UserService";

export default function VerifyEmailPage() {
    
  const navigate = useNavigate();
  const auth = useAuth();    
  const api = new AuthService();
  const [searchParams] = useSearchParams();
  const callbackUrl = searchParams.get("callbackUrl") || "/";
  const email = searchParams.get("email") || "";
  const initialState: State = {
    errors: {},
    error: {
      message: "",
      code: "",
    },
    success: false,
    defaultValues: {
      email: email,
      code: "",
    },
  };
  console.log(email);
  const [state, formAction, isPending] = useActionState(
    verifyEmail,
    initialState
  );

  useEffect(() => {
    if (state?.success) {
      getUserProfile();
      
    }
    if(state?.error && state.error.code === "EmailVerification.AlreadyVerified"){
      setTimeout(() => {
        navigate("/Auth/login")        
      }, 5000);
    }
  }, [state, callbackUrl]);

  const handleOnSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    auth.loaded(false);
  };
  const getUserProfile = async () => {
    try {
      const response = await new UsersService().getMyProfile();
      auth.login(response.data);
      console.log("User Profile:", response.data);
      navigate(callbackUrl);
    } catch (error) {
      console.error("Error fetching user profile:", error);
    }
    auth.loaded(true);
      
  };
    

  return (
    <div className="flex items-center justify-center flex-1">
      <form
        className="space-y-3 w-full max-w-md"
        action={formAction}
        onSubmit={handleOnSubmit}
      >
        <div className="flex-1 rounded-lg bg-gray-50 px-6 pb-4 pt-8">
          <h1 className={`${Fonts.lusitanaRegular} mb-3 text-2xl`}>
            Verify your email.
          </h1>
          <p>
            We sent an email to {state && state.defaultValues?.email}, please enter the code to verify your email.
          </p>
          <div className="w-full text-left">        
            <input name="email" type="hidden" value={state && state.defaultValues?.email} />
            <div className="mt-4">              
              <Input
                id="code"
                type="text"
                name="code"
                placeholder="Enter code"
                required
                minLength={6}
                aria-describedby="code-error"
                defaultValue={state && state.defaultValues?.code}
              />
              <FormError id="code-error"   message={ state.errors?.code}>                
              </FormError>
            </div>
          </div>
           <div className="flex h-8 items-end space-x-1">
            {state && !state.success &&  state.error && state.error.message && (
              <>
                <ExclamationCircleIcon className="h-5 w-5 text-red-500" />
                <p className="text-sm text-red-500">{state.error.message}</p>            
                
              </>
            )}
            
          </div>
          <p className="mt-3">{state && state.error && state.error.code === "EmailVerification.AlreadyVerified"?"You will redirect to login page in 5 seconds.":""}</p>
          <div>
            <Button className="mt-4 w-full" aria-disabled={isPending}>
              Verify <ArrowRightIcon className="ml-auto h-5 w-5 text-gray-50" />
            </Button>
          </div>
        </div>
      </form>
    </div>
  );
}
